/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import PrivacyLegalbirdOSPageMeta from "./PrivacyLegalbirdOSPageMeta";
import Container from "../../../../components/Container/Container";
import Layout from "../../../Layouts/Layout";
import PrivacyLegalbirdOS from "../../../../components/Privacy/PrivacyLegalbirdOS/PrivacyLegalbirdOS";

const PrivacyLegalbirdOSPage = () => {
  return (
    <Layout backgroundType={"landingpage"}>
      <PrivacyLegalbirdOSPageMeta />
      <Container sectionPadding={false}>
        <PrivacyLegalbirdOS />
      </Container>
    </Layout>
  );
};

export default PrivacyLegalbirdOSPage;
